import { OverflowList as OverflowListParent } from './original';
import { forwardRef } from 'react';
import {Tag} from "@/theme/ui";
import {Dropdown} from "antd";

const ItemRenderer = (item, index) => {
    return (
        <Tag
            key={index}
        >
            {item}
        </Tag>
    )
};

const OverflowRenderer = ({items}) => {
    return <OverflowItem count={items.length}/>
}

const OverflowItem = forwardRef(function OverflowItem(props, ref) {
    const {count, ...rest} = props

    return (
        <>
            {(count)
                ? (
                    <>
                        <Tag
                            ref={ref}
                            {...rest}
                        >
                            {count
                                ? `+${count}`
                                : `+5`
                            }
                        </Tag>
                    </>
                )
                : null
            }
        </>
    )
});

const DropdownOverflowRenderer = ({items}) => {
    return (
        <>
            {(items.length)
                ? (
                    <Dropdown
                        overlayClassName={'dropdown_tags'}
                        placement="topRight"
                        menu={{
                            items: items.map((item, key)=>({
                                key,
                                label: (
                                    <Tag>
                                        {item}
                                    </Tag>
                                )
                            }))
                        }}
                        trigger={['click']}
                    >
                        <OverflowItem
                            style={{
                                cursor: 'pointer',
                            }}
                            count={items.length}
                        />
                    </Dropdown>
                )
                : null
            }
        </>
    )
};

export const OverflowList = ({dropdown, overflowRenderer, ...rest}) => {

    const overflowRen = (items) =>{
        const node = dropdown
            ? <DropdownOverflowRenderer items={items}/>
            : <OverflowRenderer items={items}/>

        return overflowRenderer
            ? overflowRenderer(node, items)
            : node
    }

    return (
        <OverflowListParent
            collapseFrom="end"
            minVisibleItems={0}
            itemRenderer={ItemRenderer}
            overflowRenderer={overflowRen}
            {...rest}
        />
    );
}